// extracted by mini-css-extract-plugin
export default {"dates":"fZxmC","separator":"pRleH","testType":"R18Qd","test":"Sv4HL","goBackButton":"UsXDP","title":"l6OJL"};